export default __webpack_public_path__ + "static/africa-results-1-967457d89c5a935b0490464dd8ef816d.png";